import { useMemo, useCallback } from 'react';

//* HOC's
import { withUIContext } from 'context';

//* Components
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Image from 'components/common/Image';
import Button from 'components/common/Button';
import Pagination from 'components/common/Pagination';
import MediaLibraryPopup from 'components/common/Popups/MediaLibraryPopup';

const MediaList = ({ data, onCategoryChange, openPopup, winWidth, screenSizes, isAll }) => {
	//! Toggle popup
	const togglePopup = useCallback((libraryItemData) => {
		openPopup(<MediaLibraryPopup data={libraryItemData} />);
	}, []);

	//! Store media library items
	const storeMediaLibraryItems = useMemo(() => {
		return data.items.map((libraryItem, index) => (
			<div
				className='col-4 col-ts-6 col-m-12'
				key={index}
			>
				<div className={`media-library-item ${libraryItem.file.type}`}>
					<div className={`image-and-layer-wrap ${winWidth < screenSizes.desktopSizeXS ? 'no-hover' : ''}`}>
						{libraryItem.thumbnail?.url ? (
							<Image
								className={`media-library-item-image ${isAll ? 'all-filter-size' : ''}`}
								objectFit={'cover'}
								src={libraryItem.thumbnail.url}
								alt={libraryItem.thumbnail.alt}
							/>
						) : (
							<div className='icon-wrap'>
								<Icon
									name={libraryItem.file.type}
									className={'file-icon'}
								/>
							</div>
						)}
						<Button
							borderColor={'ColorWhite'}
							color={'ColorWhite'}
							text={'previewTheFile'}
							hoverBackground={'ColorWhite'}
							hoverColor={'ColorBigStone'}
							hoverBorderColor={'ColorWhite'}
							className={'preview-button'}
							onClick={() => togglePopup(libraryItem)}
						/>
					</div>
					<div className='media-library-item-content-wrap'>
						<Text
							className={'media-library-item-text pXS font-helvetica'}
							text={libraryItem.name}
						/>
						<Text
							className={'pXS file-type font-helvetica'}
							text={libraryItem.file.extension}
						/>
					</div>
				</div>
			</div>
		));
	}, [data, winWidth, screenSizes]);

	return (
		<Container
			full
			row
			className={'items-wrap'}
		>
			{storeMediaLibraryItems}
			<Pagination
				total={data.total}
				pageSize={data.perPage}
				pageNumbersToShow={5}
				nextIcon={<Icon name='arrow-small' />}
				prevIcon={<Icon name='arrow-small' />}
				onCategoryChange={onCategoryChange}
			/>
		</Container>
	);
};

export default withUIContext(MediaList, ['openPopup', 'winWidth', 'screenSizes']);
